import { Radio, List, Text, Button } from "../../components";
import Localization from "../../localization";
import { Enums } from "../../utils";
import Webhook from "./webhook";
import Other from "./other";
import React from "react";

const getDetails = ({ uuid, readUrl }) => {
  switch (uuid) {
    case Enums.deviceTypes.http:
      return <Webhook readUrl={readUrl} />;
    case Enums.deviceTypes.sms:
      return (
        <Text
          weight={400}
          type="secondary"
          className="m-15-t m-37-r"
          children={Localization.configure_device.sms_description}
        />
      );
    default:
      return (
        <Other
          className="m-10-b"
          subheading={Localization.configure_device.other_subheading}
        />
      );
  }
};

const Item = ({ active = false, onClick = () => {}, ...item }) => {
  return (
    <List.Item className="p-25-t p-25-b" onClick={onClick}>
      <List.Item.Meta
        avatar={<Radio checked={active} />}
        className="align-items-start"
        title={
          <div>
            <Text
              level={5}
              weight={700}
              children={item.name}
              className="cursor-pointer"
              type={active ? "primary" : "secondary"}
            />
            {active && item.type === "integration" && (
              <>
                {getDetails(item)}
                {!!item.readUrl && (
                  <Button
                    className="m-25-t"
                    title={Localization.general.read_more}
                    onClick={() => window.open(item.readUrl)}
                  />
                )}
              </>
            )}
          </div>
        }
      />
    </List.Item>
  );
};

export default Item;
